import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

// REVEX-SAAS-API - /saas_service
// SAAS-API - /saas-api

const SaasService = {
  getCompanyWalletBalance: (companyId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(
      `company-wallet/${companyId}/support/balance`
    ),

  editTwilioAccount: (
    locationId: string,
    { key, value }: { key: string; value: any }
  ) =>
    requests(SERVICE_NAME.REVEX_SAAS_API)
      .log({
        module: Module.ISV,
        entityType: EntityType.LOCATION,
        entityId: locationId,
      })
      .put(`isv-mode/twilio?locationId=${locationId}`, { key, value }),

  clearAgencyWelcomeTemplateId: (companyId: string) =>
    requests(SERVICE_NAME.SAAS_API)
      .log({
        module: Module.SAAS,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .post(`saas-dashboard/clear-location-selection/${companyId}`),

  unsubscribeYext: (payload: any) =>
    requests(SERVICE_NAME.YEXT_API).delete(`reselling/location/${payload.location_id}/unsubscribe`, payload),

  markYextUnsubscribeForStripe: (payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      "yext/mark_unsubscribe_stripe",
      payload
    ),

  unsubscribeWordpress: (query: string, payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      `wordpress/support/unsub?${query}`,
      payload
    ),

  switchToStandardWordpressPlan: (payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      "wordpress/support/agency_direct_purchase",
      payload
    ),

  cancelSpecialWordpressPlan: (payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      "support/unsubscribe_special_plan",
      payload
    ),

  markWordpressUnsubscribeForStripe: (payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      "wordpress/support/mark_unsubscribe_stripe",
      payload
    ),

  getLocationTransactionDetails: (transactionId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(
      `location-wallet-transactions/details/${transactionId}`
    ),

  deleteSaasPlans: (companyId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API)
      .log({
        module: Module.SAAS,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .get(`company/${companyId}/delete-saas-plans`, {
        params: { debugMode: true },
      }),

  disableSaasForCompany: (companyId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API)
      .log({
        module: Module.SAAS,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .get(`company/${companyId}/disable-saas-locations`, {
        params: { debugMode: true },
      }),

  disableSaasForLocation: (locationId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(
      `saas-config/${locationId}/disable-saas?debugMode=true`
    ),

  downloadCompanyWalletTransactions: (companyId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(
      `company/${companyId}/locations-wallets-under-agency`,
      { responseType: "blob" }
    ),

  skipIsv3dsVerification: (relationshipNumber: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(
      `isv-mode/internal-enable-isv-mode/${relationshipNumber}`
    ),

  disableIsvMode: (locationId: string, payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      `isv-mode/disable-isv-mode/${locationId}`,
      payload
    ),

  isvCloseAgency: (relationshipNumber: string, payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      `isv-mode/close-agency?relationshipNumber=${relationshipNumber}`,
      payload
    ),

  getISVInfoForLocation: (locationId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).get(`debug/${locationId}/twilio-id`),

  syncLocationTwilioCreds: (locationId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).put(
      `debug/${locationId}/twilio-creds-sync`
    ),

  moveCompanyOutOfISV: (relationshipNumber: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      `isv-mode/agency-out-of-isv/${relationshipNumber}`
    ),

  allowAgencyUpdateUsageLimit: (relationshipNumber: string, payload: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_API).post(
      `isv-mode/allow-update-usage-limit/${relationshipNumber}`,
      payload
    ),

  getWalletRechargeSettings: (locationId: string) =>
    requests(SERVICE_NAME.BLADE_PLATFORM_API).get(
      `support/location-wallet/${locationId}/recharge-settings`
    ),

  updateWalletRechargeSettings: (
    locationId: string,
    payload: { disableAutoRecharge?: boolean; disableManualRecharge?: boolean }
  ) =>
    requests(SERVICE_NAME.BLADE_PLATFORM_API)
      .log({
        module: Module.BLADE_PLATFORM,
        entityType: EntityType.LOCATION,
        entityId: locationId,
      })
      .post(
        `support/location-wallet/${locationId}/recharge-settings`,
        payload
      ),
};

export default SaasService;
